import React, { Fragment, useState, useEffect } from "react";

import { ReactComponent as Checked } from "~/assets/images/dashboard/Checked.svg";
import { ReactComponent as Unchecked } from "~/assets/images/dashboard/Unchecked.svg";

const CheckMark = ({game})=> {

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let targetsCount = 0;
    let claimedCount = 0;
    let lvlGame = false;
    game.actionsRewardsList.forEach((el)=> {
      el.claimed !== undefined && targetsCount ++;
      el.claimed === true && claimedCount ++;
      lvlGame = el.action === 2;
    });
    !lvlGame && setChecked(targetsCount === claimedCount);
  }, []);

  return (
    <Fragment>
      {!checked && <Unchecked style={{height: 24, width: 24}} /> }
      { checked && <Checked   style={{height: 24, width: 24}} /> }
    </Fragment>
  );
}

export default CheckMark;
